<template>
  <PrimeIconField>
    <PrimeInputIcon class="pi pi-spin pi-spinner" v-if="props.loading">
    </PrimeInputIcon>
    <PrimeInputText
      v-model="value"
      v-bind="$attrs"
      class="w-full"
      @change="changeEventHandler($event)"
      @input="inputEventHandler($event)"
      @blur="blurEventHandler($event)"
      @keyup.enter="
        () => {
          emits('enter', {});
        }
      "
      :disabled="loading || disabled"
      :invalid="hasErrors"
      :id="props.id"
      :placeholder="props.placeholder"
    />
  </PrimeIconField>
</template>

<script setup lang="ts">
import {
  type IInputEvent,
  type IChangeEvent,
  type IBlurEvent,
} from "~/scad-shared/types/interfaces";

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    inputType?: string;
    error?: string;
    loading?: boolean;
    id?: string;
    placeholder?: string;
  }>(),
  {
    disabled: false,
    loading: false,
  }
);

const hasErrors: ComputedRef<boolean> = computed(() => {
  if (props.error && props.error !== "") {
    return true;
  }
  return false;
});

const value = defineModel<string | null>("value");

const emits = defineEmits<{
  change: [event: IInputEvent];
  input: [event: IChangeEvent];
  blur: [event: IBlurEvent];
  enter: [event: any];
}>();

function changeEventHandler($event: any) {
  emits("change", { ...$event, value: value.value });
}
function inputEventHandler($event: any) {
  emits("input", { ...$event, value: value.value });
}
function blurEventHandler($event: any) {
  emits("blur", { ...$event, value: value.value });
}
</script>

<style scoped></style>
